



















import { Component, Vue, Prop } from "vue-property-decorator";
import mmsi_list from "@/config/map/mmsi.json";
import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import StandartModal from "@/components/app/standart-modal.vue";

interface IMMSIJSON {
  [x: string]: number;
}

@Component({
  components: { StandartModal, onsubmit: SubmitResetButtonGroop },
})
export default class Mmsi extends Vue {
  @Prop({ type: String, default: "" }) mmsi!: string | undefined;

  ais_mmsi = "";

  get shipName(): string {
    const mmsi: IMMSIJSON = mmsi_list;
    for (const ship of Object.keys(mmsi)) {
      if (this.ais_mmsi == String(mmsi[ship])) return ship;
    }
    return "";
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    this.$emit("updateConfig", { mmsi: this.ais_mmsi });
    this.$bvModal.hide("root-setting-mmsi");
  }

  cteatedLocales(): void {
    this.ais_mmsi = this.mmsi ? this.mmsi : "";
  }

  onReset(): void {
    this.cteatedLocales();
  }

  mounted(): void {
    this.cteatedLocales();
  }
}
